import { render, staticRenderFns } from "./UcCompanyTypeBadge.yaml?vue&type=template&id=75470425&component"
import script from "./UcCompanyTypeBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyTypeBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports